<template>
  <abf-container>
    <v-layout>
      <v-flex xs12 md6>
        <v-card class="pa-2">
          <v-card-title class="pb-0 mb-0">
            <v-avatar class="secondary">
              <v-icon dark>visibility_off</v-icon>
            </v-avatar>
            <div class="ml-3">
              <h4 class="headline">Excluded Funders</h4>
            </div>
          </v-card-title>
          <v-card-text>
            <v-layout wrap v-if="SelectedPartner.excluded_businesses.length > 0">
              <v-flex xs12>
                <p class="grey--text">Excluded Funders from this Partner's Referrals</p>
              </v-flex>
            </v-layout>
            <v-layout wrap v-if="SelectedPartner.excluded_businesses.length > 0">
              <v-flex xs8>
                <v-list>
                  <v-list-item class="mb-4" v-for="business in SelectedPartner.excluded_businesses" :key="business.id">
                    <img :alt="`${business.name}-logo`" :src="business.logo" class="question-product mr-3" />
                    <v-list-item-content>
                      <v-list-item-title>{{ business.name }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn icon ripple @click="detachExcludedFunder(business.id)">
                        <v-icon color="grey lighten-1">close</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-flex>
            </v-layout>
            <v-layout wrap v-if="SelectedPartner.excluded_businesses.length > 0">
              <v-flex xs12>
                <v-divider class="my-3"></v-divider>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs8>
                <v-autocomplete
                  :items="FunderCompanies"
                  item-text="name"
                  item-value="id"
                  v-model="excludedBusinessId"
                  label="Select a funder to exclude"
                  flat
                  dense
                ></v-autocomplete>
              </v-flex>
              <v-flex>
                <v-btn v-if="excludedBusinessId" color="accent" @click="attachExcludedFunder">Add</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </abf-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import AbfContainer from '../../Abf/AbfContainer';

export default {
  components: { AbfContainer },
  data: () => ({
    excludedBusinessId: null
  }),
  name: 'partner-excluded-funders',
  computed: {
    ...mapGetters(['SelectedPartner', 'UserHasRole', 'FunderCompanies'])
  },
  methods: {
    ...mapActions(['getFunderCompanies', 'attachExcludedBusiness', 'detachExcludedBusiness', 'addNotification']),
    attachExcludedFunder: function() {
      this.attachExcludedBusiness({
        id: this.SelectedPartner.id,
        excludedBusinessId: this.excludedBusinessId
      });
      this.excludedBusinessId = null;
    },
    detachExcludedFunder: function(excludedBusinessId) {
      this.detachExcludedBusiness({
        id: this.SelectedPartner.id,
        excludedBusinessId: excludedBusinessId
      });
    }
  },
  mounted() {
    if (this.FunderCompanies.length < 1) {
      this.getFunderCompanies();
    }
  }
};
</script>

<style scoped>
::v-deep .question-product {
  width: 100px;
}
</style>
